import {IListingState} from 'plugins/modules/listing/types';
import {PayloadAction} from '@reduxjs/toolkit';

export function createListingActions<T extends IListingState>() {
    return {
        actionSetList(state: T, {payload}: PayloadAction<T['list']>) {
            state.list = payload;
        },

        actionSetListViewType(state: T, {payload}: PayloadAction<T['listType']>) {
            state.listType = payload;
        },
    };
}
